import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import LoanApplicationFactory from '../../../domain/newLoanApplication/LoanApplicationFactory';
import Collection from '../../../domain/valueObject/Collection';
import { NewLoanApplicationStepsProps } from '../../../pages/NewLoanApplication';
import { NewLoanSteps } from '../../../utils/enums';
import PartInputField from '../../parts/PartInputField';
import BlockStepsButtons from '../BlockStepsButtons';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

interface MonthlyGrossRentsProps extends NewLoanApplicationStepsProps {}

const MonthlyGrossRents = ({
    nextStep,
    prevStep,
    newLoanEntity
}: MonthlyGrossRentsProps) => {
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm({
        mode: 'onChange',

        shouldFocusError: false,
        resolver: yupResolver(
            yup.object().shape({
                monthlyGrossRents: yup
                    .string()
                    .required('Please complete this required field.')
                    .matches(
                        /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
                        'You must specify a number.'
                    )
            })
        )
    });

    const onSubmit = (data: any) => {
        LoanApplicationFactory.makeFromForm(
            newLoanEntity,
            new Collection(data)
        );

        nextStep(NewLoanSteps.MONTHLY_GROSS_RENTS_EXTENDED);
    };

    const handlePrevStep = () => {
        LoanApplicationFactory.makeFromForm(
            newLoanEntity,
            new Collection(getValues())
        );
        prevStep(NewLoanSteps.LOAN_TYPE);
    };

    useEffect(() => {
        newLoanEntity.hasMonthlyGrossRents() &&
            setValue(
                'monthlyGrossRents',
                newLoanEntity.monthlyGrossRents.value
            );
    }, []);

    return (
        <div className="login">
            <div className="container">
                <h1 className="login__title">
                    How is your rental property cashflow?
                </h1>
                <p className="login__subtitle">Monthly Gross Rents</p>
                <div className="login__box">
                    <PartInputField
                        label="Monthly Gross Rents"
                        name="monthlyGrossRents"
                        control={control}
                        errors={errors}
                        isRequired
                        isDollarAmount={true}
                    />
                    <BlockStepsButtons
                        prevStep={handlePrevStep}
                        nextStep={handleSubmit(onSubmit)}
                    />
                </div>
            </div>
        </div>
    );
};

export default MonthlyGrossRents;
